import { GetRequest, initUrlQueryData } from "utils/initUrlQueryData.js"
import { initUrlQueryDataBigScreen } from "utils/initUrlQueryDataBigScreen.js"
import { parseColor as parseThemeColor } from "utils/parseColor.js"
import vueWorker from "vue-worker"
import Vue from "vue"
// 页面中各处交互，涉及动态修改style的显，隐
import $ from "jquery"
import eventBus from "./eventBus.js"
import ElementUI from "./elementUi/index"
import vueEcharts from "vue-echarts"
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers"
import "element-ui/lib/theme-chalk/index.css"
import "default-passive-events"
import instance from "./interceptor" //axios封装
import { v1 } from "uuid"
import md5 from "md5"
const parseColor = function (color, config = {}) {
  return parseThemeColor(color, {
    ...config,
    renderModel: config?.renderModel ?? "value",
    themeColors: this.$store.state[this.request_prefix]?.page?.themeColorList?.[0]?.color ?? this.$store.state[this.request_prefix]?.page?.themeColor
  })
}
const uuid = { v1 } //随机生成uid
import animate from "animate.css"
import * as echarts from "echarts"
import "video.js/dist/video-js.css"
import Directives from "./directives/index"
import store from "./store"
import appVue from "./App.vue"
import router from "./router/index"
import waterfall from "vue-waterfall2"
import { materialLoader } from "./core/materialLoader"
import { getOptions, changeOptionsEV, changePageAttribute } from "utils/options.js"
import { event, subPageEvent } from "utils/event"
import { saveModule, styleToSaveModule } from "utils/saveModule.js"
import cxUI from "./modules"
import stageRow from "./components/layoutStage/rows.vue"
import stageCol from "./components/layoutStage/cols.vue"
import row from "materials/layout/render/row.vue"
import col from "materials/layout/render/col.vue"
import bigScreenRow from "./components/elementComponents/layoutBigScreen/row.vue"
import bigScreenCol from "./components/elementComponents/layoutBigScreen/col.vue"
import stage from "./components/stage.vue"
import reuseMap from '@/utils/attrsReuse.js'
import { updateNormalRect } from "utils/updateData/publicDataUtils/updateNormalRect.js"
import {
  getRectAttribute,
  getAttrById,
  isBigScreenPreview,
  hasProperty,
  checkType,
  checkAndSetPrimaryVal,
  asyncTask,
  shareDataPool,
  copyToClip,
  collapseControl,
  collapseMouseDown,
  initPlugin,
  myDrag,
  isSsrPage,
  EventEmitter,
  isMobile
} from "utils"
import asyncPluginSettingSubmit from "./components/publicComponent/asyncPluginSettingSubmit.vue"
import api from "./api/index.js"
import { addHistory, undo, redo } from "utils/revork"

import codemirror from "vue-codemirror"
import "codemirror/lib/codemirror.css"
import "codemirror/theme/monokai.css"
import "codemirror/mode/css/css.js"

// ====================================== sentry ======================================
// import * as Sentry from "@sentry/vue";
// if(process.env.NODE_ENV === "production" && !process.env.VUE_APP_IS_MIRROR) { // 线上环境打包开启sentry
//   Sentry.init({
//     Vue,
//     dsn: "https://27475534e74744a2961c250d6745c55d@sentry.chaoxing.com/13",
//     release: '1.0.0',
//   });
// }
// ====================================== sentry ======================================

Vue.component("asyncPluginSettingSubmit", asyncPluginSettingSubmit)
// 注册必须的组件
echarts.use([CanvasRenderer])
Vue.use(vueWorker)
Vue.use(cxUI)
Vue.use(Directives)
Vue.use(animate)
Vue.component("v-chart", vueEcharts)
Vue.component("stage-row", stageRow)
Vue.component("stage-col", stageCol)
Vue.component("cx-row", row)
Vue.component("cx-col", col)
Vue.component("cx-big-screen-row", bigScreenRow)
Vue.component("cx-big-screen-col", bigScreenCol)
Vue.component("stage", stage)
Vue.use(waterfall)
Vue.use(codemirror)
//全局挂载可配置项获取函数和设置函数

Vue.prototype.$API = api
Vue.prototype.$myDrag = myDrag
Vue.prototype.$collapseControl = collapseControl
Vue.prototype.collapseMouseDown = collapseMouseDown
Vue.prototype.$initPlugin = initPlugin
Vue.prototype.$getOptions = getOptions
Vue.prototype.$changeOptionsEV = changeOptionsEV
Vue.prototype.$changePageAttribute = changePageAttribute
Vue.prototype.$saveModule = saveModule
Vue.prototype.$styleToSaveModule = styleToSaveModule
// 全局的获取rect的attribute
Vue.prototype.getRectAttribute = getRectAttribute //获取rect的option
Vue.prototype.isSsrPage = isSsrPage //是否是服务端渲染
Vue.prototype.getAttrById = getAttrById //根据id值获取option
Vue.prototype.hasProperty = hasProperty //判断在图表中某是否有个属性
Vue.prototype.checkType = checkType //判断数据是否为undefined
Vue.prototype.checkAndSetPrimaryVal = checkAndSetPrimaryVal //判断并设置默认值
Vue.prototype.isBigScreenPreview = isBigScreenPreview
Vue.prototype.asyncTask = asyncTask
Vue.prototype.shareDataPool = shareDataPool
Vue.prototype.$eventBus = eventBus
Vue.prototype.$event = event
Vue.prototype.$subPageEvent = subPageEvent
Vue.prototype.instance = instance
Vue.prototype.updateNormalRect = updateNormalRect
Vue.prototype.$echarts = echarts
Vue.prototype.copyToClip = copyToClip
Vue.prototype.uuid = uuid
Vue.prototype.materialLoader = materialLoader
Vue.prototype.EventEmitter = EventEmitter
Vue.prototype.$addHistory = addHistory
Vue.prototype.$undo = undo
Vue.prototype.$redo = redo
Vue.prototype.$reuseMap = reuseMap
Vue.prototype.md5 = md5
Vue.prototype.$pluginLifeCycle = {}
Vue.prototype.$parseColor = parseColor
//初始化websitid，wfwfid等
//全局绑定request_prefix用于判断vuex的stage和appstage
let reqLock = false
// 判断当前是否是编辑页，是的话只能在chrome内核下打开
// if(location.href.includes("home") || location.href.includes("appHome") || (location.href.includes("bigScreen") && !location.href.includes("bigScreenPreview"))) {
//   let isAble = false
//   // 判断是否为Chrome内核
//   if (navigator.userAgent.indexOf('Chrome')>-1) {
//     isAble = true
//   }
//   if(!isAble){
//     router.push("/homeDeviceError")
//   }
// }
console.log("location.pathname", location.pathname)
// 兼容之前的hash地址
if (location.hash) {
  location.replace(location.href.replace("#/", ""))
}
// 如果当前为预览页，需要轮播，直接进入权限页面；不需要轮播，保存起来后面判断
if (location.href.includes("bigScreenPreview")) {
  if (GetRequest().noswiper) {
    sessionStorage.setItem("closeSwiper", "1")
  }
  location.href = `/v2/p/${GetRequest().p}`
}

// 如果通过域名直接访问预览页，进入权限页面
if (
  // (location.pathname === "" || location.pathname === "/") &&
  location.pathname.indexOf("v2/p") === -1 &&
  window.previewUrl &&
  window.previewUrl.includes("bigScreenPreview")
) {
   window.isBigScreenPreviewUrl = true
  // location.href = `/v2/p/${GetRequest().p}`
}
// 如果直接进入预览页，并且由编辑页进入，关闭轮播
try {
  if (location.pathname.startsWith("/v2/p")) {
    sessionStorage.setItem("closeSwiper", "1")
  }
} catch (err) {
  console.log("外部页面跳转跨域了，不用处理")
}

// ssr的预览页，如果识别是移动端打开，直接重定向到移动端页面
if (location.href.includes("ssrPreview") && GetRequest().p && isMobile()) {
  location.href = `/v2/p/${GetRequest().p}?mh-v2-iframe=1`
}

router.beforeEach((to, from, next) => {
  // 大屏不修改标题，因为大屏的修改标题在之前
  if (to?.meta?.title && !to.path.startsWith("/v2/p") && !window.isBigScreenPreviewUrl) {
    document.title = to.meta.title
  }
  const _next = () => {
    const otherQuery = {}
    if (from.query.admin === "admin") {
      otherQuery.admin = "admin"
    }
    next({
      query: {
        ...to.query,
        ...otherQuery
      }
    })
  }

  if (to.path === "/bigScreenPreview" || to.path.startsWith("/v2/p") || window.isBigScreenPreviewUrl) {
    Vue.prototype.request_prefix = "bigScreen"
  } else if (to.path === "/appHome") {
    Vue.prototype.request_prefix = "appStage"
  } else if (to.path === "/bigScreenList") {
    Vue.prototype.request_prefix = "bigScreenList"
  } else if (to.path === "/bigScreen") {
    Vue.prototype.request_prefix = "bigScreen"
    if (!reqLock) {
      api
        .getEditPagePermission({
          pageId: to.query.p
        })
        .then(res => {
          reqLock = true
          if (!res.data.code) {
            router.push({
              path: "/bigScreenPreview",
              query: { ...to.query }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  } else if (to.path === "/ssrPreview") {
    Vue.prototype.request_prefix = "appStage"
  }  else {
    Vue.prototype.request_prefix = "stage"
  }
  window.request_prefix = Vue.prototype.request_prefix
  _next()
})
router.afterEach((to, from, next) => {
  if (to.path === "/home" || to.path === "/homeMoudles" || to.path === "/appHome" || to.path === "/bigScreen" || to.path === "/bigScreenPreview") {
    //  pc 端切换到移动端，不再请求 content 接口
    if (to.path === "/appHome" && from.path === "/home") {
      return
    }
    // 从app端切回到pc端时，执行pc版本号检测
    pageInit(to.path, from.path === "/appHome" && to.path === "/home" ? true : false)
  }
})
//设置开发环境开启vue_devtools
if (process.env.NODE_ENV === "development") {
  Vue.config.devtools = true
} else {
  console.log(process.env.NODE_ENV)
  Vue.config.devtools = true
}

Vue.use(ElementUI)

window.vueWorker = Vue.prototype.$worker

async function pageInit(toPath, checkPcVersion) {
  if (toPath !== "/bigScreen" && toPath !== "/bigScreenPreview") {
    await initUrlQueryData(checkPcVersion) // 使用await等待数据请求回来后再进行页面渲染
  }
}
;(async function () {
  if (window.location.href.indexOf("bigScreen") > -1 || location.href.includes("v2/p") || window.isBigScreenPreviewUrl) {
    await initUrlQueryDataBigScreen(true)
  }
  if (!window.previewUrl) {
    window.closeLottie()
    let time = location.href.indexOf("homeMoudles") > -1 ? 0 : 1000
    setTimeout(() => {
      window.myVue = new Vue({
        router,
        store,
        render: h => h(appVue)
      }).$mount("#app")
    }, time)
  } else {
    window.myVue = new Vue({
      router,
      store,
      render: h => h(appVue)
    }).$mount("#app")
  }

})()
